<template>
    <div>
        <b-modal
            id="add-industry-popup"
            ref="modal"
            :title="titleHeading"
            size="lg"
            hide-footer
            no-close-on-backdrop
            modal-class="hide-footer"
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-6">
                        <b-form-group
                            id="industry-code-field"
                            label="Industry Code"
                            label-for="Industry Code"
                        >
                            <b-form-input
                                id="industry-code-select"
                                v-model="formData.code"
                                v-validate="{
                                    min: 1,
                                    max: 10,
                                    regex: /^[\+\d]([0-9]*)$/,
                                    required: true,
                                }"
                                type="text"
                                placeholder="Enter industry code"
                                name="code"
                                :class="{
                                    'is-invalid': errors.has('code'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group
                            id="industry-code-field"
                            label="Industry Title"
                            label-for="Industry Title"
                        >
                            <b-form-input
                                id="industry-code-select"
                                v-model="formData.title"
                                v-validate="{
                                    min: 1,
                                    max: 75,
                                    required: true,
                                }"
                                type="text"
                                placeholder="Enter industry title"
                                name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div
                        v-for="(
                            workTypeImpact, index
                        ) in formData.workTypeImpacts"
                        v-if="
                            workTypeImpact.status == 'active' &&
                            workTypeImpact.isIndustrial == true
                        "
                        :key="index"
                        class="col-md-4"
                    >
                        <b-form-group
                            id="self-employed-field"
                            :label="workTypeImpact.title"
                            label-for="workTypeImpact.title"
                        >
                            <b-form-select
                                :id="'workTypeImpact' + index"
                                v-model="workTypeImpact.ranking"
                                v-validate="{
                                    required: true,
                                }"
                                class="form-control"
                                :options="ranking"
                                :name="workTypeImpact.title"
                                :class="{
                                    'is-invalid': errors.has(
                                        'workTypeImpact.title'
                                    ),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            type: String,
            default: null,
        },
        workTypeList: {
            type: Array,
        },
        buttonText: {
            type: String,
            default: 'Create',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup', 'data']),
        titleHeading() {
            return this.selectedItem
                ? 'Modify Industry Factor'
                : 'Add Industry Factor'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            ranking: [
                { value: null, text: 'Select Ranking', disabled: true },
                { value: 'n/a', text: 'Select Ranking' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
                { value: 'sanction', text: 'Sanctioned' },
            ],
            formData: this.initializeFormData(),
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        workTypeList(value) {
            let self = this
            if (value) {
                self.formData = self.initializeFormData()
                if (
                    self.formData.workTypeImpacts &&
                    self.formData.workTypeImpacts.length
                ) {
                    let workTypeArr = []
                    self.formData.workTypeImpacts.forEach(function (val) {
                        let obj = {}
                        obj.workTypeId = val._id
                        obj.ranking = null
                        obj.title = val.title
                        obj.status = val.status
                        obj.isIndustrial = val.isIndustrial
                        workTypeArr.push(obj)
                    })
                    self.formData.workTypeImpacts = workTypeArr
                }
            }
        },
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            let self = this
            if (value !== null && value !== undefined) {
                let workTypeArr = []
                value.workTypeImpacts.forEach(function (val) {
                    let obj = {}
                    obj.workTypeId = val.workTypeId
                    obj.ranking = val.ranking
                    obj.title = val.workType.title
                    obj.status = val.workType.status
                    obj.isIndustrial = val.workType.isIndustrial
                    workTypeArr.push(obj)
                })
                self.formData.dataSegmentId = value.dataSegmentId
                self.formData._id = value._id
                self.formData.code = value.code
                self.formData.title = value.title
                self.formData.workTypeImpacts = workTypeArr
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                code: '',
                title: '',
                isSanction: false,
                status: 'active',
                workTypeTitle: '',
                workTypeImpacts: this.workTypeList,
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    //console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
